import MeetingRoomScene from "@/models/MeetingRoomScene";

export const Zoro003MeetingRoom = new MeetingRoomScene({
    background: require('@/assets/images/scenes/zoro003/meeting/teammeeting_bg_c3.png'),
    foreground: require('@/assets/images/scenes/zoro003/meeting/teammeeting_table_c3.png')
})